import { BreadCrumbsModule } from '@shared/components';
import { CheckinButtonModule } from '@my-account/components';
import { CommonModule } from '@angular/common';
import { DSProductRecommendationsModule } from '@product-recommendations/components';
import { NgModule } from '@angular/core';
import { OrderCardsModule } from '@my-account/order-track/components';
import { OrderDetailComponent } from './order-detail.component';
import { OrderDetailRoutingModule } from './order-detail-routing.module';

@NgModule({
	declarations: [
		OrderDetailComponent
	],
	imports: [
		BreadCrumbsModule,
		CheckinButtonModule,
		CommonModule,
		DSProductRecommendationsModule,
		OrderCardsModule,
		OrderDetailRoutingModule
	]
})
export class OrderDetailModule {}
